import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const biSignInUpAccountCopyUpdateSelector = createSelector(testTargetOffersSelector, offers => offers.biSignInUpAccountCopyUpdate || Empty.Object);

export { biSignInUpAccountCopyUpdateSelector };
